const padOffsetHours = (sign, hours, minutes = 0) => {
  const paddedHours = String(hours).padStart(2, '0');
  if (minutes === 0) return `GMT${sign}${paddedHours}`;
  return `GMT${sign}${paddedHours}:${String(minutes).padStart(2, '0')}`;
};

const formatOffsetLabel = (offsetLabel) => {
  if (!offsetLabel) return null;

  const normalized = offsetLabel
    .replace('UTC', 'GMT')
    .replace('GMT', 'GMT');

  const shortMatch = normalized.match(/GMT([+-])(\d{1,2})$/);
  if (shortMatch) {
    return padOffsetHours(shortMatch[1], Number(shortMatch[2]));
  }

  const longMatch = normalized.match(/GMT([+-])(\d{1,2}):(\d{2})/);
  if (longMatch) {
    return padOffsetHours(longMatch[1], Number(longMatch[2]), Number(longMatch[3]));
  }

  return normalized;
};

export const getRetailerTimezone = () => {
  const retailerTimezone = ENV.CURRENT_RETAILER_TIMEZONE?.trim();
  if (retailerTimezone) return retailerTimezone;

  return getBrowserTimezone() || 'America/Guayaquil';
};

export const getBrowserTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getTimezoneLabel = (timeZone = getRetailerTimezone()) => {
  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'shortOffset'
    });
    const offsetPart = formatter.formatToParts(new Date()).find((part) => part.type === 'timeZoneName');
    const formatted = formatOffsetLabel(offsetPart?.value);
    if (formatted) return formatted;
  } catch (error) {
    // fall through to manual offset
  }

  try {
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'longOffset'
    });
    const offsetPart = formatter.formatToParts(new Date()).find((part) => part.type === 'timeZoneName');
    const formatted = formatOffsetLabel(offsetPart?.value?.replace('UTC', 'GMT'));
    if (formatted) return formatted;
  } catch (error) {
    // fall through to manual offset
  }

  const offsetMinutes = -new Date().getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absoluteMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absoluteMinutes / 60);
  const minutes = absoluteMinutes % 60;

  return padOffsetHours(sign, hours, minutes);
};

export const CALENDAR_SLOT_LABEL_FORMAT = {
  hour: '2-digit',
  minute: '2-digit',
  omitZeroMinute: false,
  hour12: false
};

export const addSlotDuration = (date, slotDuration = '00:30:00') => {
  const end = new Date(date);
  const [hours, minutes, seconds = 0] = slotDuration.split(':').map(Number);
  end.setHours(end.getHours() + hours, end.getMinutes() + minutes, end.getSeconds() + seconds);
  return end;
};
